module.exports = __webpack_public_path__ + "static/media/tercera_caracteristica.35fcfb6d.png";